




















































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ListViewItem from 'list-view/src/listviewitem';
import UserModel from '@views/a-model/user-model';
import DefaultModel from '@views/a-model/default-model';
import ControlValidatorGroupComponent from '../components/control-validator-group.vue';

@Component({
  name: 'users',
  components: {},
})
export default class UsersComponent extends Vue {
  innerItems: Array<any> = [];
  totalCounts = 0;
  page_number = 0;
  page_size = 4;
  isLoading = false;
  modalWindowShow = false;
  modalWindowTitle = '';
  modalWindowFunctionOk: any = null;

  addingUser: UserModel = new UserModel();
  pages = Array<ListViewItem<DefaultModel>>();

  created() {
    document.title = this.$route.meta.title;
    this.$api.AccountService.GetUserEvent;
    //1 Ammar Aschraf example@gmail.com 20.02.2019
    // this.innerItems.push({
    //   id: 1,
    //   name: "Иванов Иван иванович",
    //   email: "example1@gmail.com",
    //   dt: "2.02.2019"
    // });
    // this.innerItems.push({
    //   id: 2,
    //   name: "Петров Петр Сергеевич",
    //   email: "example2@gmail.com",
    //   dt: "20.03.2019"
    // });
    // this.innerItems.push({
    //   id: 3,
    //   name: "Сидоров Игорь Эдуардович",
    //   email: "example3@gmail.com",
    //   dt: "20.04.2019"
    // });
    // this.innerItems.push({
    //   id: 4,
    //   name: "Смирнов Игорь николаевич",
    //   email: "example4@gmail.com",
    //   dt: "20.05.2019"
    // });

    this.pages.push(new ListViewItem(new DefaultModel(1, '10'), true, false));
    this.pages.push(new ListViewItem(new DefaultModel(2, '15'), false, false));
    this.pages.push(new ListViewItem(new DefaultModel(3, '25'), false, false));
    this.pages.push(new ListViewItem(new DefaultModel(4, '100'), false, false));
    this.totalCounts = this.innerItems.length;
    this.page_size = parseInt(this.pages.filter((item) => item.Selected)[0].Value.name);
  }
  isValid(): boolean {
    return (this.$refs.validator as ControlValidatorGroupComponent).isValid();
  }

  paginationArray(ar: Array<any>) {
    return ar.slice(this.page_number * this.page_size, (this.page_number + 1) * this.page_size);
  }

  createdUser() {
    if (!this.isValid()) {
      return;
    }
    this.modalWindowShow = false;
  }

  editedUser() {
    if (!this.isValid()) {
      return;
    }
    this.modalWindowShow = false;
  }

  /**
   * Сортировка таблицы по имени полю и направлению(0,1)
   */
  onSort(sortName: string, sortType: string) {
    // console.log("sortName",sortName," sortType:",sortType)
    switch (sortName) {
      case 'id':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.id - b.id;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return b.id - a.id;
          });
          break;
        }
      case 'name':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.name < b.name ? 1 : -1;
          });
          break;
        }
      case 'email':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.email > b.email ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.email < b.email ? 1 : -1;
          });
          break;
        }
      case 'dt':
        if (sortType == '1') {
          this.innerItems.sort(function(a, b) {
            return a.dt > b.dt ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.dt < b.dt ? 1 : -1;
          });
          break;
        }
      default:
        break;
    }
  }

  onUserRemove(userId: number) {
    const index = this.innerItems.findIndex((el) => el.id == userId);
    this.innerItems.splice(index, 1);
  }

  onPaginationChanged(res: any) {
    this.page_number = res.Page - 1;
    this.page_size = res.CountOnPage;
  }
  onChangePageSize(item: any) {
    this.page_size = parseInt(this.pages.filter((item) => item.Selected)[0].Value.name);
  }
  onSearchUser() {}
  onCreateUser() {
    this.modalWindowTitle = 'Новый пользователь';
    this.modalWindowFunctionOk = this.createdUser;
    this.addingUser = new UserModel();
    this.modalWindowShow = true;
  }
  onUserEdit(userId: number) {
    this.modalWindowTitle = 'Пользователь';
    this.modalWindowFunctionOk = this.editedUser;
    this.addingUser = this.innerItems.filter((item) => item.id)[0];

    this.modalWindowShow = true;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-users.vue